
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as vip_45clubquADJaJaiKMpxsFEA6U9jkqQuJBYxrdwhOnS_45g7tVoYMeta } from "/app/pages/vip-club.vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as badgesPpR8WrSUB1T9sevAtthT_8NMk8bryGUB6uJHQMvPiWUMeta } from "/app/pages/profile/badges.vue?macro=true";
import { default as indextTormfsMuM9JVfjXPDKahOX55Vx1QMsLjAiLfci8gbMMeta } from "/app/pages/profile/coupon/index.vue?macro=true";
import { default as _91slug_93vkYARjsY6Z0yk5Bl5rizATB5aigYiWdWz8d_45r4Pj_bAMeta } from "/app/pages/profile/coupon/[slug].vue?macro=true";
import { default as fidelity9VcIkDnA99Q5bMW2zYGrY0jV6tnx7w9TD5HYtNiuY3gMeta } from "/app/pages/profile/coupon/fidelity.vue?macro=true";
import { default as couponpizsRQj5HLwKpYw4bNrzh9fv1saJRu82sT4CiduqL_45EMeta } from "/app/pages/profile/coupon.vue?macro=true";
import { default as inviteXwcC70Y6ghipY8_WCkaW4TxECjlxNL1ifl6xzNKWvhUMeta } from "/app/pages/profile/invite.vue?macro=true";
import { default as _91id_9317GGD_S2076_45DR6kOA548WW_45odYcNw_45IINwqUy0O0O8Meta } from "/app/pages/profile/offers/[id].vue?macro=true";
import { default as index_45aoqEIsAzYHHCOa6YALpA8tK9_5ot5VS_45_45sflKeHPE4Meta } from "/app/pages/profile/offers/index.vue?macro=true";
import { default as offersamaCN8wYLFcHEwZc0iU3fXwoyDNq70EB6oPJMNwk2_454Meta } from "/app/pages/profile/offers.vue?macro=true";
import { default as updateNhCdDqfB6Rusg_Vle97jVyR9p7_452lR0XiCGPYC45tNgMeta } from "/app/pages/profile/update.vue?macro=true";
import { default as indexjYE1BVSc6iX6gF8ZMf9VvmHWgWZ_45RQ3j5taBh7NkKgcMeta } from "/app/pages/assistant/index.vue?macro=true";
import { default as services2vK7qRHPDb7V4evPzec08_eDbL72XRqa2qDethwpDHwMeta } from "/app/pages/profile/services.vue?macro=true";
import { default as successxb3itF7U0tTVMSI25lCHLLY82z6A_g17_4589_4544uZRYkMeta } from "/app/pages/assistant/success.vue?macro=true";
import { default as purchasesIC05vQcmZy3S91rAFzUMVVvSisJsurflGbkoUkUicn0Meta } from "/app/pages/profile/purchases.vue?macro=true";
import { default as informativa_45privacyQxzFfmanH7CbiXt63FNjb_wafydPI7M_45gn9DMYR3wREMeta } from "/app/pages/informativa-privacy.vue?macro=true";
import { default as regolamento_45programma_45fedeltavCFrOd8YoOC8rk10fgkUDAKDxB5sEy7OeqWA_45ArMf7QMeta } from "/app/pages/regolamento-programma-fedelta.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "vip-club",
    path: "/vip-club",
    meta: vip_45clubquADJaJaiKMpxsFEA6U9jkqQuJBYxrdwhOnS_45g7tVoYMeta || {},
    component: () => import("/app/pages/vip-club.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-badges",
    path: "/profile/badges",
    component: () => import("/app/pages/profile/badges.vue")
  },
  {
    name: couponpizsRQj5HLwKpYw4bNrzh9fv1saJRu82sT4CiduqL_45EMeta?.name,
    path: "/profile/coupon",
    component: () => import("/app/pages/profile/coupon.vue"),
    children: [
  {
    name: "profile-coupon",
    path: "",
    component: () => import("/app/pages/profile/coupon/index.vue")
  },
  {
    name: "profile-coupon-slug",
    path: ":slug()",
    component: () => import("/app/pages/profile/coupon/[slug].vue")
  },
  {
    name: "profile-coupon-fidelity",
    path: "fidelity",
    component: () => import("/app/pages/profile/coupon/fidelity.vue")
  }
]
  },
  {
    name: "profile-invite",
    path: "/profile/invite",
    component: () => import("/app/pages/profile/invite.vue")
  },
  {
    name: offersamaCN8wYLFcHEwZc0iU3fXwoyDNq70EB6oPJMNwk2_454Meta?.name,
    path: "/profile/offers",
    component: () => import("/app/pages/profile/offers.vue"),
    children: [
  {
    name: "profile-offers-id",
    path: ":id()",
    component: () => import("/app/pages/profile/offers/[id].vue")
  },
  {
    name: "profile-offers",
    path: "",
    component: () => import("/app/pages/profile/offers/index.vue")
  }
]
  },
  {
    name: "profile-update",
    path: "/profile/update",
    component: () => import("/app/pages/profile/update.vue")
  },
  {
    name: "assistant",
    path: "/assistant",
    meta: indexjYE1BVSc6iX6gF8ZMf9VvmHWgWZ_45RQ3j5taBh7NkKgcMeta || {},
    component: () => import("/app/pages/assistant/index.vue")
  },
  {
    name: "profile-services",
    path: "/profile/services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "assistant-success",
    path: "/assistant/success",
    meta: successxb3itF7U0tTVMSI25lCHLLY82z6A_g17_4589_4544uZRYkMeta || {},
    component: () => import("/app/pages/assistant/success.vue")
  },
  {
    name: "profile-purchases",
    path: "/profile/purchases",
    component: () => import("/app/pages/profile/purchases.vue")
  },
  {
    name: "informativa-privacy",
    path: "/informativa-privacy",
    meta: informativa_45privacyQxzFfmanH7CbiXt63FNjb_wafydPI7M_45gn9DMYR3wREMeta || {},
    component: () => import("/app/pages/informativa-privacy.vue")
  },
  {
    name: "regolamento-programma-fedelta",
    path: "/regolamento-programma-fedelta",
    meta: regolamento_45programma_45fedeltavCFrOd8YoOC8rk10fgkUDAKDxB5sEy7OeqWA_45ArMf7QMeta || {},
    component: () => import("/app/pages/regolamento-programma-fedelta.vue")
  }
]